import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { STATUS_LABELS, STATUS_COLORS } from "../lib/api";

export default function AnimeCard({ entry, index = 0 }) {
  const rating = entry.user_rating ?? entry.mal_score;
  return (
    <Link
      to={`/anime/${entry.mal_id}`}
      data-testid={`anime-card-${entry.mal_id}`}
      className="group relative block border border-white/10 bg-neutral-950 brutal-hover"
      style={{ animation: `fadeUp 0.5s ${index * 0.03}s both ease-out` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-neutral-900">
        {entry.image_url ? (
          <img
            src={entry.image_url}
            alt={entry.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center font-mono text-xs text-neutral-600">
            NO IMAGE
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90" />
        {rating != null && (
          <div className="absolute right-2 top-2 flex items-center gap-1 border border-white/20 bg-black/70 px-2 py-1 font-mono text-[10px] text-white backdrop-blur">
            <Star className="h-3 w-3 fill-[#FF3B30] text-[#FF3B30]" />
            {Number(rating).toFixed(1)}
          </div>
        )}
        {entry.status && (
          <div
            className={`absolute left-2 top-2 border bg-black/70 px-2 py-1 font-mono text-[9px] uppercase tracking-widest backdrop-blur ${STATUS_COLORS[entry.status] || "text-white border-white/30"}`}
          >
            {STATUS_LABELS[entry.status] || entry.status}
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="line-clamp-2 min-h-[2.5rem] text-sm font-semibold leading-tight text-white">
          {entry.title}
        </h3>
        <div className="mt-2 flex items-center justify-between font-mono text-[10px] uppercase tracking-widest text-neutral-500">
          <span>{entry.episodes ? `${entry.episodes} ep` : "—"}</span>
          <span className="truncate max-w-[60%] text-right">
            {(entry.genres || []).slice(0, 2).join(" / ")}
          </span>
        </div>
      </div>
    </Link>
  );
}
